import { Box, Typography, Button } from "@mui/material";
import { getImpersonationInfo, endImpersonation } from "../utils/impersonation";

export default function ImpersonationBanner() {
  const info = getImpersonationInfo();
  if (!info) return null;

  return (
    <Box
      sx={{
        bgcolor: "warning.main",
        color: "warning.contrastText",
        px: 2,
        py: 0.75,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Typography variant="body2" fontWeight={600}>
        You are viewing as {info.targetUserName} — impersonated by {info.impersonatedByName}
      </Typography>
      <Button size="small" variant="outlined" color="inherit" onClick={endImpersonation}>
        Exit impersonation
      </Button>
    </Box>
  );
}
